import { useCallback } from "react";

import { useAuth } from "../providers/AuthProvider";
import type { AnalyticsEventInput } from "../services/analyticsClient";
import { trackAnalyticsEvent } from "../services/analyticsClient";

export function useAnalytics() {
  const { accessToken, sessionId, user } = useAuth();
  const userState = user ? "authenticated" : "anonymous";

  const track = useCallback(
    (event: AnalyticsEventInput) => {
      trackAnalyticsEvent(event, {
        accessToken,
        sessionId,
        userState
      });
    },
    [accessToken, sessionId, userState]
  );

  return { track, userState };
}
